var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22119 12.4425L9.65619 9L6.22119 5.5575L7.27869 4.5L11.7787 9L7.27869 13.5L6.22119 12.4425Z",
    fill: "#C2C7D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrGray);
export default __webpack_public_path__ + "static/media/right-arr-gray.e98e7e827e1df6938114a7a7242ac7f0.svg";
export { ForwardRef as ReactComponent };